import React, { useState, useEffect } from "react";
import InfluencerHowDesktop from "./InfluencerHowDesktop";
import InfluencerHowTablet from "./InfluencerHowTablet";
import InfluencerHowMobile from "./InfluencerHowMobile";

import rocketIcon from "../../assets/InfluencerPageGraphics/rocket.png";
import shareIcon from "../../assets/InfluencerPageGraphics/share.png";
import graphIcon from "../../assets/InfluencerPageGraphics/graph.png";
import dollarIcon from "../../assets/InfluencerPageGraphics/dollar.png";
import rocketIconHover from "../../assets/InfluencerPageGraphics/rocketHover.svg";
import shareIconHover from "../../assets/InfluencerPageGraphics/shareHover.svg";
import graphIconHover from "../../assets/InfluencerPageGraphics/graphHover.svg";
import dollarIconHover from "../../assets/InfluencerPageGraphics/dollarHover.svg";
import "./InfluencerHowItWorks.css";

const steps = [
  {
    icon: rocketIcon,
    iconHover: rocketIconHover,
    title: "Apply to Join",
    text: "Sign up in minutes. We review and approve most creators within 24 hours.",
  },
  {
    icon: shareIcon,
    iconHover: shareIconHover,
    title: "Share Brandly",
    text: "Use your unique link across your platforms—social, newsletter, blog, or DMs.",
  },
  {
    icon: graphIcon,
    iconHover: graphIconHover,
    title: "Track & Optimize",
    text: "Real-time analytics show how your link is performing.",
  },
  {
    icon: dollarIcon,
    iconHover: dollarIconHover,
    title: "Get Paid Monthly",
    text: "Earn every month your referrals stay subscribed.",
  },
];

const InfluencerHowItWorks = () => {
  const [screen, setScreen] = useState("desktop");

  useEffect(() => {
    const checkSize = () => {
      const width = window.innerWidth;
      if (width < 780) setScreen("mobile");
      else if (width < 1200) setScreen("tablet");
      else setScreen("desktop");
    };

    checkSize();
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  return (
    <section className="influencerhow-wrapper">
      <h2>
        How It <span className="influencer-page-text-green">Works</span>
      </h2>
      {screen === "desktop" && <InfluencerHowDesktop steps={steps} />}
      {screen === "tablet" && <InfluencerHowTablet steps={steps} />}
      {screen === "mobile" && <InfluencerHowMobile steps={steps} />}
    </section>
  );
};

export default InfluencerHowItWorks;
